<template>
  <div>
    <debug>
      value {{ value }}<br />
      selectedFilterElement {{ selectedFilterElement }}<br />
      value {{ value.id }}<br />
      filterList {{ filterList.map((f) => f.id) }}
    </debug>
    <div style="display: flex; flex-direction: row">
      <!-- FILTER KEY -->
      <div style="margin-right: 2px; flex: 1" :style="typeInputWidthStyle">
        <v-combobox
          v-model="selectedFilterElement"
          :items="filterList"
          :filter="keyFilter"
          item-value="id"
          outlined
          dense
          data-test-filter-key
        >
          <template #append> <div style="display: none" /> </template>
          <template #item="{ item }">
            <debug> {{ item }}</debug>
            {{ item.displayName ? $t(item.displayName) : item.key }}
          </template>
          <template #selection="{ item }">
            <debug> {{ item }}</debug>
            {{ item.displayName ? $t(item.displayName) : item.key }}
          </template>
        </v-combobox>
      </div>

      <!-- COMPARISON OPERATION  -->
      <div
        v-if="selectedFilterElement && isComparatorSelection"
        style="width: 45px; flex: 0; margin-right: 2px; margin-left: 2px"
      >
        <v-select
          v-if="isComparatorSelection"
          v-model="value.operation"
          :items="availableOperations"
          hide-details
          outlined
          dense
          data-test-filter-operation
        >
          <template #append> <div style="display: none" /> </template>
          <template #item="{ item }">
            <v-spacer />
            {{ $t(`components.filter.${item}`) }}
            <v-spacer />
          </template>
          <template #selection="{ item }">
            <v-spacer />
            <span style="position: relative; left: 2px">
              {{ $t(`components.filter.${item}`) }}
            </span>
            <v-spacer />
          </template>
        </v-select>
      </div>

      <!--  SELECTION  -->
      <div v-if="selectedFilterElement" style="margin-left: 2px; flex: 1" :style="valueInputWidthStyle">
        <filter-card-pagination-value-field
          v-model="value.value"
          :filterConfiguration="selectedFilterElement"
          :dense="true"
          :outlined="true"
        />
      </div>
      <div style="width: 24px; flex: 0; position: relative; top: 7px">
        <v-btn @click="$emit('remove')" icon class="ma-auto" small>
          <v-icon small> mdi-close </v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PaginationFilterListElement } from "@/lib/utility/data/page-filter-list-element.interface";
import { IPageFilterElement } from "@/models/page-filter-element.entity";
import { PaginationFilterOperationEnum } from "@/store/modules/base-pagination.store";
import { PageFilterTypes } from "@/lib/utility/data/page-filter-types.enum";
import { Component, Prop, Vue } from "vue-property-decorator";
import FilterCardPaginationValueField from "./FilterCardPaginationValueField.vue";
import { $t } from "@/lib/utility/t";
import Debug from "@/components/utility/Debug.vue";

@Component({
  components: {
    FilterCardPaginationValueField,
    Debug
  }
})
export default class FilterCardPaginationMenuFilterElement extends Vue {
  @Prop()
  value!: IPageFilterElement;

  @Prop()
  filterList!: PaginationFilterListElement[];

  get selectedFilterElement() {
    return this.filterList.find((f) => f.id === this.value.id) as PaginationFilterListElement;
  }

  set selectedFilterElement(selectedFilterElement: PaginationFilterListElement) {
    this.value.key = selectedFilterElement.key;
    this.value.type = selectedFilterElement.type;
    this.value.specifier = selectedFilterElement.specifier;
  }

  get isComparatorSelection() {
    return ![PageFilterTypes.BOOLEAN].includes(this.selectedFilterElement?.type as PageFilterTypes);
  }

  get typeInputWidthStyle() {
    if (!this.selectedFilterElement) {
      return "min-width:  calc(100% - 24px)";
    }

    const isComparatorSelection = this.isComparatorSelection;

    return `min-width: calc(40% - 24px ${isComparatorSelection ? "- 45px" : ""}) !important`;
  }

  get valueInputWidthStyle() {
    return "min-width: calc(60% - 24px) !important";
  }

  get allOperations() {
    return Object.values(PaginationFilterOperationEnum);
  }

  get availableOperations() {
    if (PageFilterTypes.DATE === this.selectedFilterElement?.type) {
      // Not equal does not work for dates in backend
      return this.allOperations.filter((op) => op !== PaginationFilterOperationEnum.NOT_EQUAL);
    }

    return this.allOperations;
  }

  keyFilter(item: PaginationFilterListElement, queryText: string) {
    return (JSON.stringify(item) + $t(item.displayName ?? "objects." + item.key))
      .toLowerCase()
      .includes(queryText.toLowerCase());
  }
}
</script>
